import { FC } from "react";
import * as Icon from "../icons";
import { BomPageExplainerTitle } from "../atoms/bom-page-explainer-title";

export const BomPageExplainerHeader: FC = () => {
  return (
    <>
      <Icon.HelpCircle className="text-mandarin-600" size={20} />
      <BomPageExplainerTitle />
    </>
  );
};
